export const mockotpsuccess = {
    error: false,
    data: {
        quoteId: "0Q0dq0000004sMnCAI",
        ApplicationId: "3821612",
        CurrentQueueName: "WaitDocToSignQueue",
        message: "Cargue documento a Firmar",
        documentGenerationProcessId: "0QDSAD0312DS465ca"
    }
}

// opt codigo pantalla 2

export const mockOtppantalla2Error1 = {
    error: true,
    data: {
        quoteId: "0Q0dq0000004sMnCAI",
        ApplicationId: "3821612",
        Reason: "Código inválido. Ingrese el código nuevamente"
    }
}

export const mockOtppantalla2Error2 = {
    error: true,
    data: {
        quoteId: "0Q0dq0000004sMnCAI",
        ApplicationId: "3821612",
        Decision: "No Aprobado",
        Reason: [
            {
                Desc: "Validación fallida debido a código incorrecto",
                Type: "Riesgo alto",
                Code: "OTP04"
            }
        ]
    }
}

export const mock4004 = {
    data: {
        quoteId: "0Q0dq0000004lwPCAQ",
        message: "Error 400 del servidor",
        ApplicationId: 3945751
    },
    error: true
}

